<template>
    <section class="profile-recommendations__email-inputs">
        <div class="reassurance">
            {{ $t('recommendations.invitation.emails.reassurance') }}
        </div>
        <VJoyInput
            v-model="modelValue"
            class="field"
            name="message-recipients"
            data-testid="reco-request-emails"
            :invalid="field.$error"
            :placeholder="$t('profile.creation.completion.wizard.recommendations.invitation.emails')"
        ></VJoyInput>
        <VJoyFormError v-if="field.$error" :errors="field.$errors" />
    </section>
</template>

<script setup lang="ts">
    import type {RegleFieldStatus} from '@regle/core';
    import {VJoyFormError, VJoyInput} from '@maltjoy/core-vue';

    const modelValue = defineModel<string>({required: true});

    defineProps<{
        field: RegleFieldStatus<string>;
    }>();
</script>

<style scoped lang="scss">
    .profile-recommendations {
        &__email-inputs {
            .field {
                margin-bottom: 20px;
            }

            .reassurance {
                font-style: italic;
                margin-bottom: 20px;
                font-size: var(--joy-font-size-primary-300);
            }
        }
    }
</style>
